import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgRewardIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M8.4 15H3V3h18v2.571"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM14 17v4l2.537-.888L19 21v-4M6 7h4"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgRewardIcon);
const Memo = memo(ForwardRef);
export default Memo;
